import service from './../utils/server'
const modName = '/common/web/select/';
/**
 * 用户类型
 * @param data
 */
export const userType = data => {
    return service({
        url: modName + 'userType',
        method: 'post',
        data
    })
};

export const getUserCategory = data => {
  return service({
    url: modName + 'getUserCategory',
    method: 'post',
    data
  });
};

/**
 * 仓库
 */
export const wareHouse = data => {
  return service({
    url: modName + 'wareHouse',
    method: 'post',
    data
  })
};


/**
 * 根据用户编码查询所管理的品牌列表
 * @param data
 */
export const selectBrandByUserNo = data => {
  return service({
    url: modName + 'selectBrandByUserNo',
    method: 'post',
    data
  })
};

/**
 * 查询车型
 * @param data
 * @returns {AxiosPromise}
 */
export const selectTruckType = data => {
  return service({
    url: modName + 'selectTruckType',
    method: 'post',
    data
  });
};

/**
 * 售卖类型
 */
export const selectSellType = data => {
  return service({
    url: modName + 'selectSellType',
    method: 'post',
    data
  })
};

/**
 * 差异原因
 */
export const selectTicketReason = data => {
  return service({
    url: modName + 'selectTicketReason',
    method: 'post',
    data
  })
};

/**
 * 运输商
 */
export const carrier = data => {
  return service({
    url: modName + 'carrier',
    method: 'post',
    data
  })
};

/**
 * 运输方式
 */
export const transWay = data => {
  return service({
    url: modName + 'transWay',
    method: 'post',
    data
  })
};

/**
 * 订单状态
 */
export const soStatus = data => {
  return service({
    url: modName + 'soStatus',
    method: 'post',
    data
  })
};

/**
 * 销售类型
 */
export const salesType = data => {
  return service({
    url: modName + 'salesType',
    method: 'post',
    data
  })
};

/**
 * 发货单状态
 */
export const doStatus = data => {
  return service({
    url: modName + 'doStatus',
    method: 'post',
    data
  })
};

/**
 * 配送线路
 */
export const routeInfo = data => {
  return service({
    url: modName + 'routeInfo',
    method: 'post',
    data
  })
};


/**
 * 周转箱状态
 */
export const recycleBoxStatus = data => {
  return service({
    url: modName + 'recycleBoxStatus',
    method: 'post',
    data
  })
};

/**
 * 柜台要求送货日修改原因
 */
export const counterReqArriveDateReason = data => {
  return service({
    url: modName + 'counterReqArriveDateReason',
    method: 'post',
    data
  })
};


/**
 * 货运公司
 */
export const carrierInfo = data => {
  return service({
    url: modName + 'carrier',
    method: 'post',
    data
  })
};

/**
 * 箱规
 */
export const selectBoxType = data => {
  return service({
    url: modName + 'selectBoxType',
    method: 'post',
    data
  })
};



/**
 * 处理方式
 */
export const solveType = data => {
  return service({
    url: modName + 'solveType',
    method: 'post',
    data
  })
};


/**
 * 赔偿方式
 */
export const solveCompensation = data => {
  return service({
    url: modName + 'solveCompensation',
    method: 'post',
    data
  })
};


/**
 * 赔偿金额
 */
export const solveCompensationAmount = data => {
  return service({
    url: modName + 'solveCompensationAmount',
    method: 'post',
    data
  })
};

/**
 * 差异状态
 */
export const ticketStatus = data => {
  return service({
    url: modName + 'ticketStatus',
    method: 'post',
    data
  })
};

/**
 * 差异审批状态
 */
export const ticketApproveStatus = data => {
  return service({
    url: modName + 'ticketApproveStatus',
    method: 'post',
    data
  })
};

/**
 * 差异状态
 */
export const scTicketStatus = data => {
  return service({
    url: modName + 'scTicketStatus',
    method: 'post',
    data
  })
};

/**
 * 扫码方式下拉
 */
export const selectScanInfo = data => {
  return service({
    url: modName + 'scanStatus',
    method: 'post',
    data
  })
};

/**
 * 角色
 */
export const selectRole = data => {
  return service({
    url: modName + 'roleInfo',
    method: 'post',
    data
  })
};

/**
 * 区域
 */
export const selectRegion = data => {
  return service({
    url: modName + 'selectRegionList',
    method: 'post',
    data
  })
};

/**
 * 客户类型
 */
export const selectCustTypeList = data => {
  return service({
    url: modName + 'selectCustTypeList',
    method: 'post',
    data
  })
};

/**
 * 调柜原因
 */
export const selectReqReason = data => {
  return service({
    url: modName + 'selectCabinetReason',
    method: 'post',
    data
  })
};

/**
 * 调柜需求驳回原因
 */
export const selectRejectReason = data => {
  return service({
    url: modName + 'selectRejectReason',
    method: 'post',
    data
  })
};

/**
 * 柜台类型
 */
export const selectCounterType = data => {
  return service({
    url: modName + 'selectCounterType',
    method: 'post',
    data
  })
};

/**
 * 柜台信息
 * @param data
 */
export const selectCounter = data => {
  return service({
    url: modName + 'selectCounter',
    method: 'post',
    data
  })
};

/**
 * 产品信息
 * @param data
 */
export const selectProduct = data => {
  return service({
    url: modName + 'selectProduct',
    method: 'post',
    data
  })
};

/**
 * 运输延迟原因
 * @param data
 */
export const selectDelayReason = data => {
  return service({
    url: modName + 'selectDelayReason',
    method: 'post',
    data
  })
};

/**
 * 数据源
 * @param data
 */
export const selectDataCategory = data => {
  return service({
    url: modName + 'selectDataCategory',
    method: 'post',
    data
  })
};

/**
 * 操作类型
 * @param data
 */
export const selectOptType = data => {
  return service({
    url: modName + 'selectOptType',
    method: 'post',
    data
  })
};

//查詢部门

//查詢发货仓数据
export const selectWrOriginInfo = data => {
  return service({
    url: modName + 'selectWrOriginInfo',
    method: 'post',
    data
  })
};

//查詢收货仓数据
export const selectWrDestInfo = data => {
  return service({
    url: modName + 'selectWrDestInfo',
    method: 'post',
    data
  })
};

//查詢运作单状态
export const selectShipStatusInfo = data => {
  return service({
    url: modName + 'shipStatus',
    method: 'post',
    data
  })
};

//查詢处理方式
export const selectSolveTypeInfo = data => {
  return service({
    url: modName + 'alarmSolveType',
    method: 'post',
    data
  })
};

//查询供应商
export const contractType = data =>{
  return service({
    url: modName + 'contractType',
    method: 'post',
    data
  })
}

//查询货品性质
export const goodsCategory = data =>{
  return service({
    url: modName + 'goodsCategory',
    method: 'post',
    data
  })
}

//查询基地
export const plant = data =>{
  return service({
    url: modName + 'plant',
    method: 'post',
    data
  })
}

/**
 * 门岗
 * @param data
 * @returns {*}
 */
export const getPlantGateSentry = data => {
  return service({
    url: modName + 'plantGateSentry/' + data.plantCode,
    method: 'post'
  });
};

//查询区域位置
export const plantArea = data =>{
  return service({
    url: modName + 'plantArea/'+data,
    method: 'post',
  })
}

//子库
export const storageList = data => {
  return service({
    url: modName + 'storage',
    method: 'post',
    data
  });
};

//供应商
export const supplierList = data => {
  return service({
    url: modName + 'supplier',
    method: 'post',
    data
  });
};

//库位类型
export const storageTypeList = data => {
  return service({
    url: modName + 'storageType',
    method: 'post',
    data
  });
};

export const toxin = data => {
  return service({
    url: modName + 'toxin',
    method: 'post',
    data
  });
};

export const getAppointmentStatus = data => {
  return service({
    url: modName + 'getAppointmentStatus',
    method: 'post',
    data
  });
};

/*获取工作流扭转日志*/
export const getWorkFlowLog = data => {
  return service({
    url: modName + 'getWorkFlowLog',
    method: 'post',
    data
  });
};

/*查询称重类型*/
export const weighBusinessType = data =>{
  return service({
    url: modName + 'weighBusinessType',
    method: 'post',
    data
  })
}

export const goodsType = data =>{
  return service({
    url: modName + 'goodsType',
    method: 'post',
    data
  })
}

//车辆类型搜索
export const vehicleType = data =>{
  return service({
    url: modName + 'vehicleType',
    method: 'post',
    data
  })
}

//地磅搜索
export const device = data =>{
  return service({
    url: modName + 'device',
    method: 'post',
    data
  })
}

//库位模糊搜索
export const fuzzyQueryStorage = data =>{
  return service({
    url: modName + 'fuzzyQueryStorage',
    method: 'post',
    data
  })
}

//称重类型
export const weighType = data =>{
  return service({
    url: modName + 'weighType',
    method: 'post',
    data
  })
}

//物料
export const reshipSku = data =>{
  return service({
    url: modName + 'reshipSku',
    method: 'post',
    data
  })
}

//称重类型
export const fenceType = data =>{
  return service({
    url: modName + 'fenceType',
    method: 'post',
    data
  })
}

//毒素采样类型
export const sampleType = data =>{
  return service({
    url: modName + 'sampleType',
    method: 'post',
    data
  })
}

//质检机对接
export const deviceQc = data =>{
  return service({
    url: modName + 'deviceQc',
    method: 'post',
    data
  })
}

//毒素下拉框
export const plantToxin = data =>{
  return service({
    url: modName + 'plantToxin',
    method: 'post',
    data
  })
}

//外采运作单状态
export const shipStatus = data =>{
  return service({
    url: modName + 'getCoalShipStatus',
    method: 'post',
    data
  })
}

//远程搜索供应商
export const cornSupplier = data =>{
  return service({
    url: modName + 'cornSupplier',
    method: 'post',
    data
  })
}

//外采液体辅料下拉框
export const getAccessoryOrderStatus = data =>{
  return service({
    url: modName + 'getAccessoryOrderStatus',
    method: 'post',
    data
  })
}



//外采液体辅料审批状态下拉框
export const approveStatus = data =>{
  return service({
    url: modName + 'approveStatus',
    method: 'post',
    data
  })
}

//收货状态
export const receiveStatus = data =>{
  return service({
    url: modName + 'receiveStatus',
    method: 'post',
    data
  })
}

//查询库位下的批次数据
export const selectStorageBatchByStorageId = data =>{
  return service({
    url: modName + 'selectStorageBatchByStorageId',
    method: 'post',
    data
  })
}

//装货类型
export const selectReshipLoadingType = data =>{
  return service({
    url: modName + 'selectReshipLoadingType',
    method: 'post',
    data
  })
}

//倒运玉米业务类型
export const businessType = data =>{
  return service({
    url: modName + 'selectReshipCornPlantType',
    method: 'post',
    data
  })
}

//玉米倒运运作单状态
export const getRcoStatus = data =>{
  return service({
    url: modName + 'getRcoStatus',
    method: 'post',
    data
  })
}













// WEBPACK FOOTER //
// ./src/api/selects.js